enum DD_MASK_CLASS {
  ALLOW = 'dd-privacy-allow',
  MASK = 'dd-privacy-mask',
  MASK_USER_INPUT = 'dd-privacy-mask-user-input',
  HIDDEN = 'dd-privacy-hidden',
}

export function getDDMaskClass(maskClass: keyof typeof DD_MASK_CLASS): string {
  return DD_MASK_CLASS[maskClass];
}
